import TableWrapRowsBoot from './StockItems/TableWrapRowsBoot';
import React, {useState, useEffect}  from 'react';
import * as ServerComms from './utilities/ServerComms';
import * as FormulaFunctions from './utilities/FormulaFunctions';
import NormalIcon from './StockItems/NormalIcon';

function App(props) {

  var programSetID = props.programSetID;
  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var color = props.color;
  var showIfNothing = props.showIfNothing;

  const [clientData, setClientData] = useState([]);

  function postPostFunction(response){
    setClientData(response.v);
  }

  function failFunction(){

  }
  function getClientData(){

    ServerComms.fetchSomething({u:'getClientData', programSetID, userID, signKey, sessionID}, postPostFunction, failFunction);

  }

  useEffect(()=>{
    getClientData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  function deleteClientData(clientDatabaseID) {
    return function(e) {
      ServerComms.fetchSomething({u:'deleteClientData', clientDatabaseID, programSetID, userID, signKey, sessionID}, postPostFunction, failFunction);
    }
  }

    var topUpRows = clientData.map((aRow, index)=>{
        var dateVal = FormulaFunctions.getDateFromSql(aRow.v[2]);
        return <tr><td>{aRow.v[1].v}</td><td>{dateVal}</td><td><NormalIcon icon='fe:trash' title='Delete' height='30px' onClick = {deleteClientData(aRow.v[0].v)} /></td></tr>
      })

    var clientOutput = null;
    var clientBreak = null;
    var clientHead = null;
    if (topUpRows.length === 0){
      if (!showIfNothing){
        return <div></div>
      }
      clientHead = <h3>No Client Data</h3>
    }else{
      clientHead = <h3>Client Database</h3>
      clientBreak = <br/>
      clientOutput = <TableWrapRowsBoot rows={topUpRows} headerCells={['Text', 'Date', '']}/>
    }
            
      //
                        
  return <center><div className='container-fluid py-5' style={{backgroundColor:color}}><div className='row'><div className='col-12 mx-auto text-center'>
    {clientHead}
    {clientBreak}
    {clientOutput}
   </div></div></div></center>

}

export default App;
